export const CarouselData = [
  { image: "images/slider/1.jpg", alt: "carousel slide 1" },
  { image: "images/slider/2.jpg", alt: "slide carousel 2" },
  // { image: "images/slider/3.jpg", alt: "carousel slide 3" },
  { image: "images/slider/4.jpg", alt: "carousel slide 4" },
  { image: "images/slider/5.jpg", alt: "carousel slide 5" },
];
